import { environment } from '../../../environments/environment';
import { AnaColumn } from '../forms-template.service';


export const crmProcedureGrid: AnaColumn[] = [



  {
    configuration: {
      service: 'crmProcedureForm',
      api: 'procedure',
      api_rest: true,
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'Cod',
      nCol: 2,
      widthForm: 600
    },

    itemType: "group", colCount: "1", class: "", caption: "Procedure",
    data: [


      {
        type: 'campo',
        dataField: 'Cod',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Cod',
        colAlignment: 'center',
        colWidth: 50
      },

      {
        type: 'campo',
        dataField: 'isModulo',
        colVisible: true,
        visible: false,
        dataType: 'number',
        caption: 'Tipologia',
        colAlignment: 'center',
        width: 100,
        lista: {
          dataSource: '',
          valueExpr: 'id',
          displayExpr: 'des',
          static: true,
          items: [
            { id: 0, des: 'Principale' },
            { id: 1, des: 'Opzionale' },
          ]
        }
      },
      {
        type: 'campo',
        dataField: 'Sigla',
        colVisible: true,
        dataType: 'string',
        caption: 'Sigla',
        colAlignment: 'left',
        colWidth: 120
      },
      {
        type: 'campo',
        dataField: 'Des',
        colVisible: true,
        dataType: 'string',
        caption: 'Descrizione',
        colAlignment: 'left',
        colWidth: 350
      },
      {
        type: 'campo',
        dataField: 'Ver',
        colVisible: true,
        dataType: 'number',
        caption: 'Versione',
        colAlignment: 'center',
        colWidth: 80
      },
      {
        type: 'campo',
        dataField: 'Licenza',
        colVisible: true,
        dataType: 'string',
        caption: 'Licenza',
        colAlignment: 'center',
        colWidth: 100
      },
      {
        type: 'campo',
        dataField: 'Assistenza',
        colVisible: true,
        dataType: 'string',
        caption: 'Assistenza',
        colAlignment: 'center',
        colWidth: 120
      },
      {
        type: 'campo',
        dataField: 'Vendite',
        colVisible: false,
        dataType: 'string',
        caption: 'Vendite',
        colAlignment: 'center',
        colWidth: 100
      },
      {
        type: 'campoSpecial',
        dataField: "Tipo",
        caption: "Tipo Procedura",
        colVisible: false,
        editorType: 'dxSelectBox',
        colWidth: 450,
        lista: {                                                     //Definisce la tiologia di campoSpecial, in questo caso è una LookUp, ha le stesse caratteristiche della Lista solo che possibile definire delle colonne per far apparire una griglia al suo interno in NicaAnagrafica
          dataSource: 'tipoprocedure',
          valueExpr: 'Cod',
          displayExpr: 'Descrizione',
          caption: 'Tipo Procedura',
          static: false,
          wingap: false,
          //related: ['descrizione|cerDescrizione'],  //Relaziona un campo prensente nel lookUp con un altro campo presente della Form o nella griglia
          colonne: [                                //In nica Anagrafica definendo le colonne sarà possibile far visualizzare una griglia all'interno della select tipo lookup                    
            {
              dataField: 'Descrizione',
              //dataType: '',
              caption: 'Descrizione'

            }
          ]

        }
      },
      {
        type: 'campo',
        dataField: 'Note',
        colVisible: true,
        dataType: 'string',
        caption: 'Note',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'Block',
        dataType: 'string',
        caption: 'Stato',
        colAlignment: 'center',
        width: 50,
        lista: {
          dataSource: 'Disabilitato',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
        }
      },
    ]

  }
];

export const crmProcedureForm: AnaColumn[] = [
  {
    itemType: 'group',
    caption: 'Modifica Procedura',
    class: '',
    groupDataField: 'ModificaProcedura',
    colCount: 4,
    colSpan: 2,
    data: [

      {
        type: 'campo',
        dataField: 'Cod',
        visible: false,
        dataType: 'string',
        caption: 'Cod',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'Sigla',
        dataType: 'string',
        caption: 'Sigla',
        class: 'crm_procedure_editor',
        nCol: 3,
        maxLength: 15,
        validation: [
          { type: "required", message: "Campo Sigla obbligatorio" },
        ],
      },

      {
        type: 'campo',
        dataField: 'Des',
        dataType: 'string',
        caption: 'Descrizione',
        class: 'crm_procedure_editor',
        nCol: 7,
        maxLength: 45,
        validation: [
          { type: "required", message: "Campo Descrizione obbligatorio" },
        ],
      },

      { type: 'empty', colSpan: '4', },
      //----------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'isModulo',
        colVisible: true,
        dataType: '',
        caption: '',
        labelVisible: false,
        class: 'radio_procedure',
        nCol: 4,
        editorType: 'dxRadioGroup',
        validation: [
          { type: "required", message: "Scelta Procedura obbligatoria" },
        ],
        radioGroup: {
          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,
          items: [
            {
              icon: 'glyphicon icon-locked',
              value: '0',
              descrizione: 'Principale',

              alignment: 'left',

            },
            {
              icon: 'glyphicon icon-locked',
              value: '1',
              descrizione: 'Opzionale',

              alignment: 'left',
            },
          ]
        },
      },
      {
        type: 'campo',
        dataField: 'accettaModuli',
        dataType: 'boolean',
        caption: 'Accetta Opzionali',
        editorType: 'dxSwitchBox',
        class: 'h-100 d-flex ms-2',
        nCol: 3,
        disabled: false,
        switchBox: {
          trueValue: 1,
          falseValue: 0,
          defaultValue: 1,
          switchedOnText: 'Si',
          switchedOffText: 'No',
          height: 24
        }
      },
      {
        type: 'campo',
        dataField: 'Block',
        dataType: '',
        caption: '',
        class: 'radio_procedure',
        nCol: 3,
        labelVisible: false,
        disabled: false,
        validation: [
          { type: "required", message: "Scelta Attiva/Disattiva obbligatoria" },
        ],
        editorType: 'dxRadioGroup',
        radioGroup: {
          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,
          items: [
            {
              icon: 'glyphicon icon-locked',
              value: '0',
              descrizione: 'Attiva',
              alignment: 'left',

            },
            {
              icon: 'glyphicon icon-locked',
              value: '1',
              descrizione: 'Disattiva',
              alignment: 'left',
            },
          ]
        },
      },


      { type: 'empty', colSpan: '4', },
      {
        type: 'campo',
        dataField: 'Licenza',
        dataType: 'string',
        caption: 'Licenza',
        class: 'crm_procedure_editor',
        nCol: 3,
        maxLength: 18,
        acceptOnlyCharacters: environment.ONLY_NUMBER_CHARACTERS_VIRGOLE_PUNTI,
        validation: [
          { type: "required", message: "Campo Licenza obbligatorio" },
        ]
      },

      {
        type: 'campo',
        dataField: 'Assistenza',
        dataType: 'string',
        caption: 'Assistenza',
        class: 'crm_procedure_editor',
        nCol: 3,
        maxLength: 18,
        acceptOnlyCharacters: environment.ONLY_NUMBER_CHARACTERS_VIRGOLE_PUNTI,
        validation: [
          { type: "required", message: "Campo Assistenza obbligatorio" },
        ]
      },
      {
        type: 'campo',
        dataField: 'Ver',
        dataType: 'string',
        caption: 'Versione',
        class: 'crm_procedure_editor',
        nCol: 4,
        maxLength: 6,
        acceptOnlyCharacters: environment.ONLY_NUMBER_CHARACTERS_VIRGOLE_PUNTI,
        validation: [
          { type: "required", message: "Campo Versione obbligatorio" },
        ]
      },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'Note',
        dataType: 'string',
        caption: 'Note',
        editorType: 'dxTextArea',
        class: 'crm_procedure_editor',
        nCol: 10,
      },
      { type: 'empty', colSpan: '4', },

    ]
  },





]


export const crmProcedureModificaPrezzi: AnaColumn[] = [
  {
    itemType: 'group',
    caption: 'Modifica Prezzi',
    class: '',
    groupDataField: 'ModificaPrezzi',
    colCount: 1,
    colSpan: 2,
    data: [
      {
        type: 'campo',
        dataField: 'percLic',
        dataType: 'number',
        caption: 'Percentuale Licenza %',
        class: '',
        nCol: 5,
        labelWidth: 140,

        acceptOnlyCharacters: environment.ONLY_NUMBER_CHARACTERS_VIRGOLE_PUNTI
      },
      {
        type: 'campo',
        dataField: 'percAss',
        dataType: 'number',
        caption: 'Percentuale Assistenza %',
        class: '',
        nCol: 5,
        labelWidth: 140,
        acceptOnlyCharacters: environment.ONLY_NUMBER_CHARACTERS_VIRGOLE_PUNTI
      },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'applicaClienti',
        dataType: 'boolean',
        caption: 'Applica a tutti i clienti',
        editorType: 'dxSwitchBox',
        class: 'h-100 d-flex',
        nCol: 5,
        labelWidth: 140,
        disabled: false,
        switchBox: {
          trueValue: 1,
          falseValue: 0,
          defaultValue: 0,
          switchedOnText: 'Si',
          switchedOffText: 'No',
          height: 24,
        }
      },

    ],

  },
]
